import React from 'react';
export function TopBanner() {
  return <div className="bg-[#175445] text-[#fbf7dd] py-2 px-4 md:px-8" data-id="element-459">
      <div className="max-w-7xl mx-auto flex justify-center items-center text-xs md:text-sm font-bold tracking-wide" data-id="element-460">
        <div className="flex items-center gap-2 text-center" data-id="element-461">
          <span className="text-[#FFC107]" data-id="element-462">COMING SOON</span>
          <span data-id="element-463">SECURE CARAVAN, MOTORHOME & BOAT STORAGE IN PERTH'S NORTH</span>
        </div>
      </div>
    </div>;
}